import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

interface MenuItemProps {
    target?: string | undefined;
    badgeStyleClass?: string;
    label: string;
    icon?: any;
    url?: string;
    to?: string;
    menuItem?: MenuItemProps[];
    command?: ((event: any) => void);
    disabled?: boolean;
}

interface AppSubmenuProps {
    className?: string;
    items?: MenuItemProps[];
    onMenuItemClick: null |((event: any, item: MenuItemProps, index: number) => void);
    root?: boolean;
}

const AppSubmenu: React.FC<AppSubmenuProps> = ({className, items, root}) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const onMenuItemClicked = (event: any, item: MenuItemProps, index: number) => {
        if (item.disabled) {
            return true;
        }

        if (item.command) {
            item.command({originalEvent: event, item: item})
        }

        if (index === activeIndex) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    }

    const renderLinkContent = (item: MenuItemProps) => {
        let submmenuIcons = item.menuItem && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;

        return(
            <React.Fragment>
                <FontAwesomeIcon icon={item.icon} ></FontAwesomeIcon>
                <span>{item.label}</span>
                {submmenuIcons}
            </React.Fragment>
        );
    };

    const renderLink = (item: MenuItemProps, i: number) => {
        let content = renderLinkContent(item);

        if (item.to) {
            return (
                <NavLink activeClassName="active-route" to={item.to} onClick={(e) => onMenuItemClicked(e, item, i)} exact target={item.target}>
                    {content}
                </NavLink>
            )
        }
        else {
            return (
                <a href={item.url} onClick={(e) => onMenuItemClicked(e, item, i)} target={item.target}>
                    {content}
                </a>
            );
        }
    }

    let itemsList = items && items.map((item, i) => {
        let active = activeIndex === i;
        let styleClass = classNames(item.badgeStyleClass, { 'active-menuitem': active && !item.to });

        return (
            <li className={styleClass} key={i}>
                {item.menuItem && root === true && <div className="arrow"></div>}
                {renderLink(item, i)}
                <CSSTransition classNames="p-toggleable-content" timeout={{ enter: 1000, exit: 450 }} in={active} unmountOnExit>
                    <AppSubmenu items={item.menuItem} onMenuItemClick={onMenuItemClicked} />
                </CSSTransition>
            </li>
        )
    });

    return itemsList ? <ul className={className}>{itemsList}</ul> : null; 
};

interface AppMenuProps {
    model: MenuItemProps[];
    onMenuItemClick: null| ((event: any, item: MenuItemProps, index: number) => void);
}

const AppMenu: React.FC<AppMenuProps> = ({model, onMenuItemClick}) => {
    return (
        <div className="layout-menu-container">
            <AppSubmenu items={model} className="layout-menu" onMenuItemClick={onMenuItemClick} root={true} />
        </div>
    );
};

export default AppMenu;